module.exports = __webpack_public_path__ + "img/brand-yandex.732c4028.svg";